export default __webpack_public_path__ + "static/media/recruiting-management.b961a78e.png";